import {Plural, Trans} from '@lingui/macro';
import React from 'react';

import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {InboxModel} from '../../../../models/api/inboxModel';
import {RuleModelStrict} from '../../../../models/api/ruleModel';
import {InboxItem} from './ruleImpact/inboxItem';
import {
  StyledRulesImpactDialog,
  StyledRulesImpactHeadline,
  StyledRulesImpactList,
} from './ruleImpact/ruleImpactGeneric';

/*
 * Type.
 */

interface ImpactedInboxesDialogProps {
  rule: RuleModelStrict;
  inboxes: ReadonlyArray<InboxModel>;
  onCancel: Handler;
}

/*
 * Component.
 */

export const ImpactedInboxesDialog = ({onCancel, inboxes, rule}: ImpactedInboxesDialogProps) => (
  <StyledRulesImpactDialog
    onRequestClose={onCancel}
    title={<Trans id="rule-editor-impacted-inboxes-title">Inboxes</Trans>}
  >
    <StyledRulesImpactHeadline>
      <Trans id="rule-editor-impacted-inboxes-headline-start">
        Your rule &quot;{rule.name}&quot; affects conversations in
      </Trans>{' '}
      <strong>
        <Trans id="rule-editor-impacted-inboxes-amount">{inboxes.length} other</Trans>{' '}
        <Plural id="rule-editor-impacted-inboxes-length" value={inboxes.length} one="inbox" other="inboxes" />
      </strong>
    </StyledRulesImpactHeadline>

    <StyledRulesImpactList>
      {inboxes.map((inbox) => (
        <InboxItem key={inbox.id} inbox={inbox} />
      ))}
    </StyledRulesImpactList>
  </StyledRulesImpactDialog>
);
